import { apiPath } from "../../constants";
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';
import { addSuccessMessage } from "../SnackBar";

export const USERS_POST_REQUEST = 'POST_USERS_REQUEST';
export const USERS_POST_FAILURE = 'POST_USERS_FAILURE';
export const USERS_POST_SUCCESS = 'POST_USERS_SUCCESS';

export const createUser = (data) => {
    return function(dispatch) {
        dispatch(createUserRequest());
        return axios(apiRequestOptions(apiPath.USER.CREATE, data))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(addSuccessMessage('User successfully created'));
                dispatch(createUserSuccess(response.data));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(createUserFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const createUserRequest = () => ({ type: USERS_POST_REQUEST });

const createUserFailure = (error) => ({ type: USERS_POST_FAILURE, error });

const createUserSuccess = (user) => ({ type: USERS_POST_SUCCESS, user });
